<template>
  <div class="cooperation">
    <!--合作案例 -->
    <Header></Header>
    <Default></Default>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Default from "@/components/default";
import Footer from "@/components/footer";
export default {
  name: 'Cooperation',
  components: { Header, Footer,Default },
  created(){
    sessionStorage.setItem("tabId",4)
  },
}
</script>

<style scoped>
.cooperation{
  width: 100%;
  height: 100vh;
  background: #171f30;
  overflow: auto;
}
</style>
